import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/organizations/:organization_id/machines', params, query, config)
  },
}
